import React from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Quote } from '../../../../models/quote.model';
import { Order } from '../../../../models/order.model';
import { Invoice } from '../../../../models/invoice.model';

export interface AppSaleViewSignaturesProps {
  record: any | Quote | Order | Invoice
};

const AppSaleViewSignatures: React.FunctionComponent<AppSaleViewSignaturesProps> = ({record}) => {
  const {lang} = StateLanguage()

  return (
    <div className="card card-flush">
      <div className="card-header">
        <div className="card-title">
          <h4>{lang.labels.signatures}</h4>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="dataTables_wrapper">
          <div className="table-responsive">
            <table className="table align-middle table-row-dashed gy-2 mb-2">
              { (record.signatures ?? []).length > 0
                ?
                <tbody>
                  { (record.signatures ?? []).map (( (item: string, index: number) => { return (
                    <tr key={index} className="row-dashed fw-bold">
                      <td className="w-100px text-muted text-nowrap">{lang.labels.signature} [{index + 1}]:</td>
                      <td className="min-w-500px text-secondary text-justify">{item}</td>
                    </tr>
                  )}))}
                </tbody>
                :
                <tbody>
                  <tr className="text-secondary fw-bold">
                    <td colSpan={2} className="text-center">{lang.labels.noRecordsFound}</td>
                  </tr>
                </tbody>
              }
            </table>
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppSaleViewSignatures;
